import { Alert } from "flowbite-react"
import { useRef, useState } from "react"
import { ExclamationTriangleIcon } from "@heroicons/react/24/solid"
import AdminSidebar from "../../components/sidebar/AdminSidebar"

const AdminDashboard = () => {
  const [errMsg, setErrMsg] = useState("")
  const errRef = useRef<HTMLInputElement>(null)

  return (
    <>
      <AdminSidebar />
      <div className="p-4 sm:ml-64">
        <div className="">
          <section id="users">
            <h1 className="text-left text-2xl md:text-4xl font-bold text-gray-800 dark:text-white mt-24 mb-5 mx-3 md:mx-0">
              DASHBOARD
            </h1>
            <div className={!errMsg ? "sr-only" : ""}>
              <Alert
                color="failure"
                icon={ExclamationTriangleIcon}
                onDismiss={function onDismiss() {
                  setErrMsg("")
                }}
              >
                <span ref={errRef}>{errMsg}</span>
              </Alert>
            </div>
          </section>
        </div>
      </div>
    </>
  )
}

export default AdminDashboard
